import React from 'react';
import { Badge, BadgeProps } from '@landr/maestro';
import { Attribute } from 'types/attributes';
import { Link } from 'react-router-dom';
import { attributeKindToRoute } from '../helpers/attributeKindToRoute';

export const NavigableAttributes = ({
    code,
    displayName,
    kind,
    options,
}: {
    code?: Attribute['code'];
    displayName: Attribute['displayName'];
    kind?: Attribute['kind'];
    options?: BadgeProps;
}) => {
    const route = attributeKindToRoute(kind);

    if (code && route) {
        return (
            <Badge
                as={Link}
                to={`/${route}/${code}`}
                label={displayName}
                textTransform="uppercase"
                {...options}
            />
        );
    }

    return <Badge label={displayName} textTransform="uppercase" {...options} />;
};
